import Swiper, { Navigation, Pagination, Autoplay } from 'swiper/core';
Swiper.use([ Navigation, Pagination, Autoplay ]);
export default function runSwiper()
{
	document.querySelectorAll('.js-info-swiper').forEach(container => {
		new Swiper (container.querySelector('.swiper-container'), {
			loop: true,
			speed: 1000,
			spaceBetween: 7,
			slidesPerView: 1.2,
			centeredSlides: true,
			autoplay: {
				delay: 3000,
			},
			preloadImages: false,
			lazy: {
				loadOnTransitionStart: false,
				loadPrevNextAmount: 1,
			},
			navigation: {
				nextEl: container.querySelector('.swiper-button-next'),
				prevEl: container.querySelector('.swiper-button-prev')
			},
			breakpoints: {
				520: {
					centeredSlides: false,
					slidesPerView: 3,
					spaceBetween: 16
				},
				960: {
					centeredSlides: false,
					slidesPerView: 4,
					spaceBetween: 16
				}
			}
		});
	});

	var swiper = new Swiper(".js-template-swiper", {
        navigation: {
          nextEl: ".js-template-swiper-next",
          prevEl: ".js-template-swiper-prev",
        },
		slidesPerView: 1,
        spaceBetween: 0,
		speed: 1000,
		breakpoints: {
			768: {
				slidesPerView: 3,
        		spaceBetween: 30,
			},
		}
	});
}